// extracted by mini-css-extract-plugin
module.exports = {"agenda":"Agenda-agenda-3HrPB"};